import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api } from '../api';
import AnimeCard from '../components/AnimeCard';

export default function SearchResults() {
  const [searchParams] = useSearchParams();
  const q = searchParams.get('q') || '';

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    if (!q) {
      setResults([]);
      return;
    }
    setLoading(true);
    setError(null);
    api.anime.search(q)
      .then((d) => setResults(d.results || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <div className="page search-page">
      <div className="search-page-header">
        {!q ? (
          <p className="search-page-status">Escribí algo en la barra de búsqueda.</p>
        ) : loading ? (
          <p className="search-page-status">Buscando <strong>"{q}"</strong>…</p>
        ) : (
          <p className="search-page-status">
            <strong>{results.length}</strong> resultado{results.length !== 1 ? 's' : ''} para <strong>"{q}"</strong>
          </p>
        )}
      </div>

      {error && <p className="state-error">{error}</p>}

      {!loading && results.length > 0 && (
        <div className="results-grid">
          {results.map((anime) => <AnimeCard key={anime.id} anime={anime} />)}
        </div>
      )}

      {!loading && !error && q && results.length === 0 && (
        <p className="search-page-empty">Sin resultados para "{q}". Intentá con otro nombre.</p>
      )}
    </div>
  );
}
